import React from "react";
import OnboardingLayout from "@components/onboarding/onboarding_layout";

const OnboardingApplication = () => {
  return null;
};

OnboardingApplication.layout = (page: React.ReactNode) => (
  <OnboardingLayout>{page}</OnboardingLayout>
);

export default OnboardingApplication;
